import { apiConstants } from "../../../utils/apiConstants"
import { apiTypes } from "../../../utils/apiTypes"
import apiRequestType from "../../apiRequestType"

const getDomainNames = () => {
    return apiRequestType(apiTypes.GET, apiConstants.ADMIN.USER_MANAGEMENT.GET_DOMAIN_NAMES)
}

export default getDomainNames